
/* styles */
require("!!./../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!./../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-d2dfe3dc&scoped=true!./../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./EditPackage.vue")

var Component = require("!./../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../../node_modules/vue-loader/lib/selector?type=script&index=0!./EditPackage.vue"),
  /* template */
  require("!!./../../../node_modules/vue-loader/lib/template-compiler?id=data-v-d2dfe3dc!./../../../node_modules/vue-loader/lib/selector?type=template&index=0!./EditPackage.vue"),
  /* scopeId */
  "data-v-d2dfe3dc",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/admin/EditPackage.vue
// module id = 464
// module chunks = 1